import styled from 'styled-components'
import { breakpoint } from '../../shared/theme'

const NavigationArrow = styled.img`
	cursor: pointer;
	height: 16px;
	width: 10px;
	z-index: 5;
	left: ${(props) => (props.left ? '-3%' : 'auto')};
	right: ${(props) => (props.left ? 'auto' : '-3%')};

	@media ${breakpoint('tablet')} {
		height: 30px;
		width: 19px;
		left: ${(props) => (props.left ? '-10%' : 'auto')};
		right: ${(props) => (props.left ? 'auto' : '-10%')};
	}
`

export default NavigationArrow
